export const DIMENSION_UNIT = {
  IN: 'in',
  CM: 'cm',
  MM: 'mm',
} as const

export type DimensionUnit = typeof DIMENSION_UNIT[keyof typeof DIMENSION_UNIT]

export const OPTION_DIMENSION_UNIT = [
  {label: 'in', value: DIMENSION_UNIT.IN},
  {label: 'cm', value: DIMENSION_UNIT.CM},
  {label: 'mm', value: DIMENSION_UNIT.MM},
]

export const WEIGHT_UNIT = {
  OZ: 'oz',
  LB: 'lb',
  GM: 'gm',
  KG: 'kg',
} as const

export type WeightUnit = typeof WEIGHT_UNIT[keyof typeof WEIGHT_UNIT]

export const OPTION_WEIGHT_UNIT = [
  {label: 'oz', value: WEIGHT_UNIT.OZ},
  {label: 'lb', value: WEIGHT_UNIT.LB},
  {label: 'gm', value: WEIGHT_UNIT.GM},
  {label: 'kg', value: WEIGHT_UNIT.KG},
]

export const DIMENSIONS = ['length', 'width', 'height']
export const DIMENSIONS_PLACEHOLDER = {length: 'L', width: 'W', height: 'H'}

export const RATE_SERVICES_KEY = 'RATE_SERVICES'
